/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/27/14
 * Time: 11:54 AM                                                                                  RevisionedModel
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");

    var AcdEditModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        AcdEditModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.RoutingConfig,
            defaults: {
                id: "0" //currently always 0 - will change in the not so near future
                //"type": "ACD",
//                "acdParams": {
//                    "callPresentationTimeout": 800,
//                    "autoAcceptingSetting": true,
//                    "awayOnTimeout": true
//                }
            },
            name: "AcdEditModel",
            initialize:function(options){
                //this.resource.url = this.resource.url.replace("{routeId}", this.get("id"));
            }

        });
    });
    return AcdEditModel;
});
